import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const WhatsAppButton = () => {
  const whatsappNumber = "529844594738";
  
  return (
    <div className="fixed left-4 bottom-4 z-[9999]">
      <motion.a 
        href={`https://wa.me/${whatsappNumber}`} 
        target="_blank" 
        rel="noreferrer"
        className="flex items-center gap-3 bg-green-500 text-white p-4 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.6)] border-2 border-white hover:bg-green-600 transition-colors relative group"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 20, delay: 1 }}
        whileHover={{ scale: 1.1 }}
      >
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-30"></div>
        <SafeIcon icon={FaWhatsapp} className="text-3xl relative z-10" />
        <div className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center border-2 border-green-500 animate-bounce shadow-sm z-20">
          1
        </div>
      </motion.a>
    </div>
  );
};

export default WhatsAppButton;